import { Component } from '@angular/core';
import { Location } from '@angular/common';

import { HttpErrorStatuses } from '~shared/modules/error-handler';

@Component({
  selector: 'app-server-error-page',
  styleUrls: ['./server-error.component.scss'],
  templateUrl: './server-error.component.html',
})
export class ServerErrorPageComponent {
  errorStatus = HttpErrorStatuses.ServerError;

  constructor(private readonly location: Location) { }

  refreshPage() {
    this.location.back();
  }
}
